<template>
    <div v-if="!this.$store.state.isMobile">
        <el-row :gutter="20">
            <el-col :span="6" v-for="(item, index) in list" >
                <el-card :body-style="{ padding: '0px' }" shadow="hover">
                    <div style="height: 200px;width: 100%;background-color: #7DA39A"></div>
<!--                    <img :src="item.img" class="image">-->
                    <div style="padding: 12px;">
                        <span>{{item.title}}</span>
                        <div class="bottom clearfix">
                            <time class="time">{{ item.content }}</time>

                        </div>

                        <el-button type="text" class="button" @click="homeCardItemClick(item.href)">查看详情</el-button>
                    </div>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    export default {
        name: "CardP",
        data() {
            return {
                currentDate: new Date(),
                list:[
                    {
                        img:'http://heiline.ltd/ademo/demoImg/jianli.jpg',
                        title:'项目简介',
                        content:'富文本，博客',
                        href:'/MyselfP',
                    },
                    {
                        img:'http://heiline.ltd/ademo/demoImg/beidanci.jpg',
                        title:'背单词',
                        content:'最有效的单词记忆方式',
                        href:'/LearnEnglishP',
                    },
                    {
                        img:'http://heiline.ltd/ademo/demoImg/biji.jpg',
                        title:'笔记文档',
                        content:'打造最便利的第二大脑',
                        href:'/NoteP',
                    },
                    {
                        img:'http://heiline.ltd/ademo/demoImg/shujia.jpg',
                        title:'书架',
                        content:'整理理出最有价值的书籍',
                        href:'/BookP',
                    },


                ]
            };
        },
        methods:{
            homeCardItemClick(link){
                // alert(aaa);
                this.$router.replace(link);
            }
        }
    }
</script>

<style scoped>
    .time {
        font-size: 13px;
        color: #999;
    }

    .bottom {
        margin-top: 13px;
        line-height: 12px;
    }

    .button {
        padding: 0;
        float: center;
        left: auto;
    }

    .image {
        width: 100%;
        display: block;
    }

    .clearfix:before,
    .clearfix:after {
        display: table;
        content: "";
    }

    .clearfix:after {
        clear: both
    }
</style>